import layoutReducer from './reducers';

export {default as layoutActions} from './actions';
export {default as layoutSelectors} from './selectors';

export default layoutReducer;
